export const SIGN_UP_API = '/api/security/register'
export const LOGIN_API = '/api/security/login'
export const LOGIN_TWO_FACTOR_AUTH_API = '/2fa_check'
export const SEND_RESET_API = '/api/security/send-reset'
export const GET_CAPTCHA_API = '/api/security/captcha'
export const RESET_PASSWORD_API = '/api/security/reset'
export const REGISTER_CONFIRM_API = '/api/security/register/confirm'
export const GOOGLE_REGISTRATION_AUTH_URL_API =
  '/api/google-integration/registration/auth-url'
export const GOOGLE_REGISTRATION_AUTH_API =
  '/api/google-integration/registration/auth'
